import React from 'react';
import './App.css';
import MapScreen from './screens/MapScreen';
import OrdersByTimeAndRegion from './screens/OrdersByTimeRegion';
import MainMenu from './components/MainMenu';
import { BrowserRouter } from 'react-router-dom';


global.authorization = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiI1ZGUyMjM5Nzc2ODEzNzQxMTRmZTUzODMiLCJleHAiOjE1NzU3MDYxNjcxOTN9.QYJU1ZiCQYkXsEaAjsFun4NpQCqnXwUESgbV2CfKBxM'

function App() {

  return (
    <BrowserRouter>
      <MainMenu />
    </BrowserRouter>

  );
}

export default App;
